import React from 'react';

import { Button, Modal, WrapperFlex } from '@unimed-fesp/components';

import { VscError, VscFile } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as ArquivoUploadActions } from '../../../store/ducks/arquivoUpload';
import {
  ModalContent,
  ModalContentWrapper,
  ModalFooter,
  ModalHeader,
} from '../../molecules/Modal';

import theme from '../../../styles/theme';
import LoadingSpinner from '../../molecules/LoadingSpinning';
import { Container, ContentText, Message } from './styles';

function ModalRelatoriosAcoes({
  isOpen,
  onClick,
  idTask,
  tipoModal,
  downloadArquivo,
  podeReprocessar,
}) {
  const mensagem = {
    erro1: `Pedimos desculpas, pois um erro inesperado ocorreu e o
    processamento falhou. Uma nova tentativa será executada
    automaticamente em alguns minutos. Se desejar, reporte este
    problema para o responsável pelo sistema informando o código da
    atividade abaixo:`,
    erroNaoPodeReprocessar: `Pedimos desculpas, pois um erro inesperado ocorreu e o
    processamento falhou. Se desejar, reporte este
    problema para o responsável pelo sistema informando o código da
    atividade abaixo:`,
  };

  return (
    <Modal isOpen={isOpen} onClick={onClick} height={400} width={460}>
      <ModalContentWrapper>
        <ModalContent overflow="hidden" maxHeight="none">
          {tipoModal === 'error' && (
            <ConteudoErrors
              mensagem={
                podeReprocessar
                  ? mensagem.erroNaoPodeReprocessar
                  : mensagem.erro1
              }
              idTask={idTask}
              onClick={onClick}
            />
          )}
          {tipoModal === 'download' && (
            <ConteudoDownload
              downloadArquivo={downloadArquivo}
              onClick={onClick}
            />
          )}
        </ModalContent>
      </ModalContentWrapper>
      <ModalFooter />
    </Modal>
  );
}

export default ModalRelatoriosAcoes;

function ConteudoErrors({ mensagem, idTask, onClick }) {
  const { getUltimoErroTask } = useSelector((state) => state.task);

  if (getUltimoErroTask.loading) {
    return <LoadingSpinner />;
  }

  return (
    <Container>
      <VscError color="#ED1651" size="50" />
      <Message text="Erro!" />
      <WrapperFlex column gap={16} alignCenter marginTop={16}>
        {getUltimoErroTask.data?.erroDeNegocio ? (
          <ContentText>{getUltimoErroTask.data.erro}</ContentText>
        ) : (
          <ContentText>{mensagem}</ContentText>
        )}

        <ContentText>{idTask}</ContentText>
        <Button
          tipo="primary"
          marginBottom={30}
          display="block"
          background="#ED1651"
          border="#ED1651"
          type="button"
          width={100}
          font="16px unimed_slabregular"
          onClick={onClick}
        >
          Sair
        </Button>
      </WrapperFlex>
    </Container>
  );
}

function ConteudoDownload({ downloadArquivo, onClick }) {
  const { getArquivo } = useSelector((state) => state.arquivoUpload);

  return (
    <Container>
      <VscFile color={theme.greenDefault} size="50" />
      <Message text="Download de Relatório!" />
      <WrapperFlex column gap={16} alignCenter marginTop={16}>
        {getArquivo.loading ? (
          <WrapperFlex padding={20} column gap={10}>
            <ContentText>
              Seu relatório ficará pronto em breve, o arquivo está sendo
              montado.
            </ContentText>
            <LoadingSpinner />
          </WrapperFlex>
        ) : (
          <ContentText>Seu relatório está pronto.</ContentText>
        )}

        {getArquivo.success && getArquivo.response.arquivo !== '' && (
          <Button
            tipo="primary"
            marginBottom={30}
            display="block"
            type="button"
            font="16px unimed_slabregular"
            onClick={() =>
              downloadArquivo(
                getArquivo.response.nome,
                getArquivo.response.arquivo
              )
            }
          >
            Download
          </Button>
        )}
      </WrapperFlex>
    </Container>
  );
}
